import { SelectOption } from 'global';
import { SaleType } from '../../types';

export const saleTypeOptions: SelectOption<SaleType>[] = [
  { label: 'Financing', value: SaleType.Financing },
  { label: 'Cash', value: SaleType.Cash },
];
